import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const DeleteIcon: React.FunctionComponent<IconProps> = ({
  width = 34,
  height = 34,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxHeight={34} viewBoxWidth={34} {...rest}>
    <path d="M23.75 8.98438V11H10.25V8.98438H13.6023L14.599 8H19.401L20.3977 8.98438H23.75ZM11.2013 23.9844V11.9844H22.7987V23.9844C22.7987 24.5156 22.6023 24.9844 22.2097 25.3906C21.8171 25.7969 21.3641 26 20.8507 26H13.1493C12.6359 26 12.1829 25.7969 11.7903 25.3906C11.3977 24.9844 11.2013 24.5156 11.2013 23.9844Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/icon/delete.icon.tsx